var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m52.607 24.693 2.896-1.672c.475-.274.638-.882.364-1.357l-2.981-5.164c-.274-.475-.882-.638-1.357-.364l-2.902 1.676c-3.192-3.736-7.619-6.382-12.651-7.307v-3.349c0-.549-.445-.994-.994-.994h-5.963c-.549 0-.994.445-.994.994v3.348c-5.032.925-9.459 3.57-12.651 7.307l-2.902-1.676c-.475-.274-1.083-.112-1.357.364l-2.981 5.164c-.274.475-.112 1.083.364 1.357l2.896 1.672c-1.632 4.602-1.717 9.774 0 14.615l-2.896 1.672c-.475.274-.638.882-.364 1.357l2.981 5.164c.274.475.882.638 1.357.364l2.902-1.676h33.252l2.902 1.676c.475.274 1.083.112 1.357-.364l2.981-5.164c.274-.475.112-1.083-.364-1.357l-2.896-1.672c1.633-4.602 1.718-9.774.001-14.614z",
    fill: "#00a0c8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m50 43v3.98l-1.37-.79c-2.7 3.15-6.26 5.52-10.32 6.74-.63.2-1.28.36-1.94.49-.07-.13-.14-.27-.19-.42h-8.36c-.05.15-.12.29-.19.42-.66-.13-1.31-.29-1.94-.49-4.06-1.22-7.62-3.59-10.32-6.74l-1.37.79v-3.98c0-2.12 1.65-3.85 3.73-3.99 2.59 5.27 8.01 8.89 14.27 8.89s11.68-3.62 14.27-8.89c2.08.14 3.73 1.87 3.73 3.99z",
    fill: "#0082aa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    fill: "#f0f0f0",
    r: 15.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m46.27 39.01c-2.59 5.27-8.01 8.89-14.27 8.89s-11.68-3.62-14.27-8.89c.09-.01.18-.01.27-.01v-1c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1h2v-1c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v1h2v-1c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v1c.09 0 .18 0 .27.01z",
    fill: "#d2d2d2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m50 44v10.19c0 3.39-2.895 6.109-6.374 5.784-2.325-.217-4.26-1.896-5.002-4.11l-.396-1.181c-.136-.408-.518-.683-.948-.683h-10.56c-.43 0-.812.275-.948.682l-.452 1.348c-.986 2.933-4.083 4.604-7.125 3.745-2.533-.716-4.195-3.154-4.195-5.786v-9.989c0-2.209 1.791-4 4-4h28c2.209 0 4 1.791 4 4z",
    fill: "#fab400"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m35 52c0 .77-.29 1.47-.77 2h-4.46c-.48-.53-.77-1.23-.77-2 0-1.66 1.34-3 3-3s3 1.34 3 3z",
    fill: "#dc9600"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30 46.5h-2c-.276 0-.5.224-.5.5s.224.5.5.5h2c.276 0 .5-.224.5-.5s-.224-.5-.5-.5z",
    fill: "#dc9600"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36.5 47c0-.276-.224-.5-.5-.5h-2c-.276 0-.5.224-.5.5s.224.5.5.5h2c.276 0 .5-.224.5-.5z",
    fill: "#dc9600"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23 47c.552 0 1-.448 1-1s-.448-1-1-1-1-.448-1-1-.448-1-1-1-1 .448-1 1-.448 1-1 1-1 .448-1 1 .448 1 1 1 1 .448 1 1 .448 1 1 1 1-.448 1-1 .448-1 1-1z",
    fill: "#dc9600"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 48,
    fill: "#dc9600",
    r: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 44,
    fill: "#dc9600",
    r: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 46,
    fill: "#dc9600",
    r: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 46,
    fill: "#dc9600",
    r: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23 38h-4c-.552 0-1 .448-1 1v1h6v-1c0-.552-.448-1-1-1z",
    fill: "#00143c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m45 38h-4c-.552 0-1 .448-1 1v1h6v-1c0-.552-.448-1-1-1z",
    fill: "#00143c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 53,
    fill: "#00143c",
    r: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30 48.5h-2c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2c.276 0 .5.224.5.5s-.224.5-.5.5z",
    fill: "#00143c"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36 48.5h-2c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h2c.276 0 .5.224.5.5s-.224.5-.5.5z",
    fill: "#00143c"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m23 46c-.552 0-1-.448-1-1 0-.552-.448-1-1-1-.552 0-1 .448-1 1 0 .552-.448 1-1 1-.552 0-1 .448-1 1 0 .552.448 1 1 1 .552 0 1 .448 1 1 0 .552.448 1 1 1 .552 0 1-.448 1-1 0-.552.448-1 1-1 .552 0 1-.448 1-1 0-.552-.448-1-1-1z",
    fill: "#00143c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 49,
    fill: "#00143c",
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 45,
    fill: "#00143c",
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 47,
    fill: "#00143c",
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 47,
    fill: "#00143c",
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m37 42h-10c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1h10c.552 0 1 .448 1 1v2c0 .552-.448 1-1 1z",
    fill: "#00143c"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31.196 33c-.619 0-1.083-.566-.962-1.173l1.608-8.039c.092-.458.494-.788.962-.788.619 0 1.083.566.962 1.173l-1.608 8.039c-.092.458-.494.788-.962.788z",
    fill: "#d2d2d2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27.63 30.75c.907.631-.014 1.999-.92 1.39l-4.962-3.308c-.594-.396-.594-1.268 0-1.664l4.962-3.308c.868-.62 1.849.743.92 1.39l-4.13 2.75z",
    fill: "#d2d2d2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36.37 25.251c-.907-.631.014-1.999.92-1.39l4.962 3.308c.594.396.594 1.268 0 1.664l-4.962 3.308c-.868.62-1.849-.743-.92-1.39l4.13-2.75z",
    fill: "#d2d2d2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31.196 34c-.619 0-1.083-.566-.962-1.173l1.608-8.039c.092-.458.494-.788.962-.788.619 0 1.083.566.962 1.173l-1.608 8.039c-.092.458-.494.788-.962.788z",
    fill: "#c80a50"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27.63 31.75c.907.631-.014 1.999-.92 1.39l-4.962-3.308c-.594-.396-.594-1.268 0-1.664l4.962-3.308c.868-.62 1.849.743.92 1.39l-4.13 2.75z",
    fill: "#c80a50"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m36.37 26.251c-.907-.631.014-1.999.92-1.39l4.962 3.308c.594.396.594 1.268 0 1.664l-4.962 3.308c-.868.62-1.849-.743-.92-1.39l4.13-2.75z",
    fill: "#c80a50"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameDev);
export default __webpack_public_path__ + "static/media/game_dev.f4af493e010f85d3b09e38a68e223375.svg";
export { ForwardRef as ReactComponent };